export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-bold-4107ea7910287a5796ea5282deb8e345.eot";